import "./instrument.js"
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes.js";
import "./App.css";
import {
  AppMainProvider,
  PolarisProvider,
  QueryProvider
} from "./components/providers/index.js";
import { Provider } from "react-redux";
import { Frame } from "@shopify/polaris";
import * as FullStory from "@fullstory/browser";
import { useEffect } from "react";

import { store } from "./store/index.js";

export default function App() {
  //https://app.fullstory.com
  useEffect(() => {
    FullStory.init({
      orgId: "o-1SZWTK-na1",
      devMode: process.env.NODE_ENV === "development",
      recordOnlyThisIFrame: true
    });
  }, []);

  // Any .tsx or .jsx files in /pages will become a route
  // See documentation for <Routes /> for more info
  // @ts-ignore
  const pages = import.meta.globEager("./pages/**/!(*.test.[jt]sx)*.([jt]sx)");

  return (
    <PolarisProvider>
      <BrowserRouter>
        <QueryProvider>
          <Provider store={store}>
            <Frame>
              <AppMainProvider>
                <Routes pages={pages} />
              </AppMainProvider>
            </Frame>
          </Provider>
        </QueryProvider>
      </BrowserRouter>
    </PolarisProvider>
  );
}
